import React from 'react'
import GeoFenceRoute from './components/GeoFence';
import MDBox from 'components/MDBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
// import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
// import { LoadScript } from "@react-google-maps/api";
function GeoFence() {
  return (
 <DashboardLayout>
  <DashboardNavbar />
      <MDBox   sx={{ 
        height: "93vh",  
        overflow: "hidden" 
      }}>
          <GeoFenceRoute />
      </MDBox>
    </DashboardLayout>
  )
}

export default GeoFence;
